(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /* Deacon Lane product studio enhancements — mirrors the product-v2.html
     mockup's behaviour on top of the AvisPlus Product Options app:
       1. builds a live "Your selections" summary in the sticky media column
       2. marks each numbered option step complete (green check) once answered
     The app injects its markup asynchronously and re-renders on variant change,
     so everything is idempotent and driven by a MutationObserver. All work is
     guarded — on products without the app, nothing renders. */
  (function () {
    'use strict';

    function text(el) {
      return (el ? el.textContent : '').replace(/\s+/g, ' ').trim();
    }

    // Resolve the human label for a checked radio/checkbox.
    function labelFor(input) {
      if (input.id) {
        var safeId =
          window.CSS && CSS.escape ? CSS.escape(input.id) : input.id.replace(/["\\]/g, '\\$&');
        var lbl;
        try {
          lbl = document.querySelector('label[for="' + safeId + '"]');
        } catch (e) {
          lbl = null;
        }
        if (lbl) return text(lbl);
      }
      var wrap = input.closest('label');
      if (wrap) return text(wrap);
      return input.getAttribute('aria-label') || input.value || '';
    }

    // Derive the current value of one AvisPlus option group. Only genuine
    // single-choice selections count toward the summary — checkbox groups
    // (e.g. the "Assign Thread Colors" matrix) and free-text notes are
    // deliberately skipped so "Your selections" lists only what the shopper
    // picked, not every available field.
    function optionValue(opt) {
      // Native <select>
      var sel = opt.querySelector('select');
      if (sel && sel.value) {
        var o = sel.options[sel.selectedIndex];
        if (o && o.value !== '') return text(o);
      }
      // Free-text / number inputs (excludes <textarea> notes)
      var txt = opt.querySelector(
        'input[type="text"], input[type="number"], input[type="email"], input[type="tel"], input[type="date"]'
      );
      if (txt && txt.value && txt.value.trim()) return txt.value.trim();
      // Checked radios only (checkboxes are modifiers, not primary selections)
      var checked = Array.prototype.slice.call(
        opt.querySelectorAll('input[type="radio"]:checked')
      );
      if (checked.length) {
        var labels = checked.map(labelFor).filter(Boolean);
        if (labels.length) return labels.join(', ');
      }
      // Custom swatch / button values — scope to the app's real value controls
      // so a stray `.selected`/`.active` on static markup (headings, tabs,
      // descriptions) can't leak in as a phantom "selection".
      var active = opt.querySelector(
        '.avis-style-value-button.selected, .avis-style-value-button.active,' +
          '.avis-option-value-item.selected, .avis-option-value-item.active,' +
          '.avis-option-value-item[aria-checked="true"], [role="radio"][aria-checked="true"]'
      );
      if (active) {
        return (
          active.getAttribute('title') ||
          active.getAttribute('aria-label') ||
          text(active)
        ).trim();
      }
      return '';
    }

    // Locate the AvisPlus options block. The app doesn't always emit the
    // `.app-avis-product-options-block` wrapper that every rule-10 style and this
    // script key off — the options can render directly inside
    // `.avpoptions-container__v2` / `.avpoptions-container`. When the wrapper is
    // missing we tag the real container with that class so all the styling (pink
    // panel, per-section boxes, numbered badges) applies uniformly — otherwise
    // trailing sections like "Additional Services" fall back to the bare pink.
    function findBlock() {
      var block = document.querySelector('.app-avis-product-options-block');
      if (!block) {
        block =
          document.querySelector('.avpoptions-container__v2') ||
          document.querySelector('.avpoptions-container');
        if (block) block.classList.add('app-avis-product-options-block');
      }
      return block;
    }

    // Create (once) the summary box in the sticky media column.
    function ensureSummary() {
      var existing = document.querySelector('.dl-selections');
      if (existing) return existing;
      var host =
        document.querySelector('.product__media-wrapper') ||
        document.querySelector('.product__info-container');
      if (!host) return null;
      var box = document.createElement('div');
      box.className = 'dl-selections';
      var title = document.createElement('span');
      title.className = 'dl-selections__title';
      title.textContent = 'Your selections';
      var chips = document.createElement('div');
      chips.className = 'dl-selections__chips';
      box.appendChild(title);
      box.appendChild(chips);
      host.appendChild(box);
      return box;
    }

    // Read the current value of each NATIVE Shopify variant option from Dawn's
    // <variant-selects> picker (dropdown, swatch, or pill). These are the
    // product's real variants and must show in the summary regardless of whether
    // the AvisPlus app is present. Scoped to the main product so quick-add /
    // recommended-product pickers elsewhere on the page don't bleed in.
    function nativeSelections() {
      var out = [];
      var scope = document.querySelector('product-info') || document;
      var root = scope.querySelector('variant-selects');
      if (!root) return out;
      Array.prototype.slice
        .call(root.querySelectorAll('.product-form__input'))
        .forEach(function (group) {
          var value = '';
          // Dropdown / swatch-dropdown: the selected <option>.
          var sel = group.querySelector('select');
          if (sel && sel.value) {
            var o = sel.options[sel.selectedIndex];
            value = o ? text(o) : sel.value;
          }
          // Swatch: the live value mirror in the legend.
          if (!value) {
            var dsv = group.querySelector('[data-selected-value]');
            if (dsv) value = text(dsv);
          }
          // Pill / button: the checked radio (use its clean value attribute,
          // not the label, to avoid the visually-hidden "sold out" text).
          if (!value) {
            var checked = group.querySelector('input[type="radio"]:checked');
            if (checked) value = checked.value || labelFor(checked);
          }
          if (value) out.push(value.trim());
        });
      return out;
    }

    var lastSig = null;

    // The app collapses conditional sections by setting the option's inline
    // style to `display:none` (often `!important`) / `visibility:hidden`.
    function isHiddenOption(el) {
      var s = window.getComputedStyle(el);
      return s.display === 'none' || s.visibility === 'hidden';
    }

    function isHeadingOpt(opt) {
      return !!opt.querySelector('.ap-options__heading');
    }

    // Tag each VISIBLE option so CSS can draw one box per section. This ONLY
    // toggles classes — it never creates, moves, or removes DOM nodes — so it
    // cannot spawn stray divs and never fights the MutationObserver (which
    // watches childList, not attributes). Fully idempotent.
    //   .dl-step-start → top of a box.
    //   .dl-step-end   → bottom of a box (the row before the next start / last row).
    // A box starts at: the first visible option; a heading; or a switch/toggle
    // (e.g. "View DL Specs…") — BUT a switch that sits directly under a heading
    // (e.g. the "Additional" toggle under the "Additional Services" heading)
    // stays inside that heading's box instead of starting its own. Hidden options
    // are skipped, so a collapsed section leaves no empty box and caps land on
    // real visible rows.
    function tagSteps(block) {
      var visible = [];
      Array.prototype.slice.call(block.querySelectorAll('.avp-option')).forEach(function (opt) {
        if (isHiddenOption(opt)) {
          opt.classList.remove('dl-step-start', 'dl-step-end');
        } else {
          visible.push(opt);
        }
      });
      var starts = visible.map(function (opt, idx) {
        var prev = visible[idx - 1];
        var isSwitch = opt.classList.contains('ap-options__switch-container');
        return idx === 0 || isHeadingOpt(opt) || (isSwitch && !(prev && isHeadingOpt(prev)));
      });
      visible.forEach(function (opt, idx) {
        opt.classList.toggle('dl-step-start', starts[idx]);
        opt.classList.toggle('dl-step-end', idx === visible.length - 1 || starts[idx + 1]);
      });
    }

    // Flag mini-design image-swatch options so CSS renders them as the mockup's
    // mini-card grid. Keyed on the option title containing "mini" so the font
    // image swatches (and any other image swatches) keep their compact look.
    function tagMiniDesign(block) {
      Array.prototype.slice.call(block.querySelectorAll('.avp-option')).forEach(function (opt) {
        var title = opt.querySelector('.apo-title, .avp-option-title');
        var isMini = !!(title && /mini/i.test(title.textContent || ''));
        opt.classList.toggle('dl-mini-cards', isMini);
      });
    }

    function refresh() {
      // Start from the native Shopify variants — these appear even on products
      // without the AvisPlus app.
      var chips = nativeSelections();

      // Then fold in genuine AvisPlus picks. Headings and collapsed/hidden
      // conditional sections are skipped so only what the shopper actually chose
      // becomes a chip — no static section text, no phantom rows.
      var block = findBlock();
      if (block) {
        tagSteps(block);
        tagMiniDesign(block);
        Array.prototype.slice.call(block.querySelectorAll('.avp-option')).forEach(function (opt) {
          if (isHeadingOpt(opt) || isHiddenOption(opt)) {
            opt.classList.remove('dl-step-complete');
            return;
          }
          var value = optionValue(opt);
          opt.classList.toggle('dl-step-complete', !!value);
          if (value) chips.push(value);
        });
      }

      // Drop duplicates (a native option and an app option can echo the same
      // value) while preserving order.
      var seen = {};
      chips = chips.filter(function (v) {
        var key = v.toLowerCase();
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });

      // Bail before writing anything if nothing changed. This is essential: the
      // MutationObserver watches this subtree, so writing on every call would
      // loop forever. Reset when our own box has been removed (e.g. the media
      // column re-rendered on a variant change).
      var sig = chips.join('||');
      if (sig === lastSig && document.querySelector('.dl-selections')) return;
      lastSig = sig;

      var box = ensureSummary();
      var chipWrap = box ? box.querySelector('.dl-selections__chips') : null;
      if (chipWrap) {
        chipWrap.innerHTML = '';
        chips.forEach(function (value) {
          var chip = document.createElement('span');
          chip.className = 'dl-sel-chip';
          var label = document.createElement('span');
          label.className = 'dl-sel-chip__label';
          label.textContent = value;
          chip.appendChild(label);
          chipWrap.appendChild(chip);
        });
        box.classList.toggle('is-visible', chips.length > 0);
      }
    }

    var raf;
    function scheduleRefresh() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(refresh);
    }

    // Re-read whenever the shopper edits an app option OR a native Shopify
    // variant (the native picker lives in <variant-selects>, outside the app
    // block, so it must be watched explicitly).
    function isRelevantTarget(el) {
      return (
        el &&
        el.closest &&
        el.closest('.app-avis-product-options-block, variant-selects')
      );
    }

    function init() {
      document.addEventListener('input', function (e) {
        if (isRelevantTarget(e.target)) scheduleRefresh();
      });
      document.addEventListener('change', function (e) {
        if (isRelevantTarget(e.target)) scheduleRefresh();
      });
      document.addEventListener('click', function (e) {
        if (isRelevantTarget(e.target)) scheduleRefresh();
      });

      // The app renders (and re-renders on variant change) asynchronously.
      var root = document.querySelector('product-info') || document.body;
      if (root && 'MutationObserver' in window) {
        new MutationObserver(scheduleRefresh).observe(root, {
          childList: true,
          subtree: true,
          // Also watch inline `style` so revealing/collapsing a conditional
          // section (the app toggles display:none) re-runs the boxing. Our own
          // code only toggles classes, never inline style, so this can't loop.
          attributes: true,
          attributeFilter: ['style'],
        });
      }
      scheduleRefresh();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
